jQuery(function () {
	jQuery('#zip-btn').click(function (event) {
		AjaxZip3.zip2addr('zip', '', 'address01', 'address02');
		return false;
	})
})
